export default {
  "base": [
    "text-primary border-b border-transparent hover:border-primary font-medium focus-visible:outline-primary [&>code]:border-dashed hover:[&>code]:border-primary hover:[&>code]:text-primary",
    "transition-colors [&>code]:transition-colors"
  ]
}